module.exports = {
  siteTitle: 'BitNational', // Site title.
  siteTitleShort: 'BitNational', // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: 'Bitnational Cryptocurrency Services', // Alternative site title for SEO.
  siteLogo: '/logos/logo-1024.png', // Logo used for SEO and manifest.
  siteUrl: 'https://bitnational.netlify.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: 'Bitnational Cryptocurrency Services.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteFBAppID: '', // FB Application ID for using app insights
  googleAnalyticsID: '', // GA tracking ID.
  googleMapsAPIKey: 'AIzaSyAsFN7UFyCxCJ8oDE3zaHOnOy_3krIOqEs',
  postDefaultCategoryID: '', // Default category for posts.
  dateFromFormat: 'MM/DD/YYY', // Date format used in the frontmatter.
  dateFormat: 'DD/MM/YYYY', // Date format for display.
  userName: 'User', // Username to display in the author segment.
  userTwitter: '', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'North Pole, Earth', // User location to display in the author segment.
  userAvatar: 'http://i.pravatar.cc/150', // User avatar to display in the author segment.
  userDescription: 'Some description', // User description to display in the author segment.
  supportEmail: 'support@bitnational.com',
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  socialMediaLinks: {
    facebook: 'https://www.facebook.com/bitnational/',
    twitter: 'https://twitter.com/BitNational',
    youtube: 'https://www.youtube.com/channel/UCst-vQ9cP8hVbSNpHOxZ4xw',
    linkedin: 'https://www.linkedin.com/company/bitnational-inc/',
    instagram: 'https://www.instagram.com/bitnational/',
    telegram: 'https://t.me/bitnational',
  },
  copyright: `Copyright © ${new Date().getFullYear()}. Bitnational`, // Copyright string for the footer of the website and RSS feed.
  themeColor: '#212457', // Used for setting manifest and progress theme colors.
  backgroundColor: '#212457', // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./data/SiteConfig.js